import Ajax from '../util/ajax';
import { hastaTransmitterDeleted } from '../reducers/hastaTransmittersSlice';
export function deleteHastaTransmitter(id, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/hasta-transmitter/' + id;
        ajax.del(url, undefined, () => {
            dispatch(hastaTransmitterDeleted(id));
            okCallback();
        }, () => {
            if (errorCallback != undefined) {
                errorCallback();
            }
        });
    };
}
